const BASE_FACETS = [
	'MusicalStyles',
	'Moods',
	'Instrumentations',
	'ProductionGenres',
	'Toolkit',
] as const

const FACETS_BY_LOCALE: Record<string, string[]> = {
	en: [...BASE_FACETS],
	de: BASE_FACETS.map((facetName) => `${facetName}_De`),
	fr: BASE_FACETS.map((facetName) => `${facetName}_Fr`),
	es: BASE_FACETS.map((facetName) => `${facetName}_Es`),
	it: BASE_FACETS.map((facetName) => `${facetName}_It`),
	jp: BASE_FACETS.map((facetName) => `${facetName}_Jp`),
	pt: BASE_FACETS.map((facetName) => `${facetName}_Pt`),
	cn: BASE_FACETS.map((facetName) => `${facetName}_Cn`),
}

export const getFacetsForLocale = (languageCode: string): string[] => {
	if (languageCode === 'ja') {
		return FACETS_BY_LOCALE.jp
	}

	if (languageCode === 'zh') {
		return FACETS_BY_LOCALE.cn
	}

	return FACETS_BY_LOCALE[languageCode] ?? FACETS_BY_LOCALE.en
}
